import { render, staticRenderFns } from "./DialogPost.vue?vue&type=template&id=eb3ea3b6&"
import script from "./DialogPost.vue?vue&type=script&lang=js&"
export * from "./DialogPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports